import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

const FeaturesTiles = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner pt-0',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    pushLeft && 'push-left'
  );

  const sectionHeader = {
    title: 'About Us',
    paragraph: ""
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container" >
        <div className={innerClasses}>
          <SectionHeader id="about" data={sectionHeader} className="center-content" />
          <div className={tilesClasses}>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="mb-16">
                    <Image
                      src={require('./../../assets/images/vittal_avatar.png')}
                      alt="Features tile icon 01"
                      width={94}
                      height={94} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Sai Vittal Battula
                  </h4>
                  <p className="m-0 text-sm">
                    Student, Entrepreneur, Writer, Programmer, and Aviation Addict
                  </p>
                  <div className="mt-16">
                    <ButtonGroup>
                      <Button tag="a" color="primary" wideMobile href="https://mergeurl.netlify.app/o/3aqSf" target="_blank" rel="noopener noreferrer">
                        Website
                      </Button>
                    </ButtonGroup>
                  </div>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="mb-16">
                    <Image
                      src={require('./../../assets/images/mehant_avatar.png')}
                      alt="Features tile icon 02"
                      width={96}
                      height={96}
                      />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Mehant Kammakomati
                  </h4>
                  <p className="m-0 text-sm">
                    Student, Developer, Open-Source Contributor, and Technical Writer
                  </p>
                  <div className="mt-16">
                    <ButtonGroup>
                      <Button tag="a" color="primary" wideMobile href="https://mergeurl.netlify.app/o/3aqSg" target="_blank" rel="noopener noreferrer">
                        Website
                      </Button>
                    </ButtonGroup>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;
